import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

function LearnBreadcrumb() {
  const location = useLocation();
  const isSubpage = location.pathname.startsWith('/learn/') && location.pathname !== '/learn';

  const pageName = location.pathname
    .split('/')
    .pop()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <nav aria-label="breadcrumb" className="mb-4" style={{ backgroundColor: 'transparent' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.95rem' }}>
        <Link to="/learn" style={{ color: '#3eab73', textDecoration: 'none' }}>
          Learn
        </Link>
        {isSubpage && (
          <>
            <FaChevronRight size={12} style={{ color: '#666' }} />
            <span style={{ color: '#333' }}>{pageName}</span>
          </>
        )}
      </div>
    </nav>
  );
}

export default LearnBreadcrumb;
